<template>
    <div class="np-group" :class="classes">
        <button 
            v-for="tab in tabs" 
            :key="tab.id"
            class="np-btn pe-3 me-3" 
            :class="selectedTab == tab.id ? 'np-btn-secondary active' : 'np-outline'"
            @click="switchTo(tab.id)"
        >
            <svg class="icon"><use :href="tab.icon"></use></svg>
            {{ tab.label }}
        </button>      
    </div>
</template>

<script>
import Config from '../../config.js'

export default {
    props: {
        tabs: {
            type: Array,
            default: () => [
                {
                    id: 'id_string',
                    label: 'label_string',
                    icon: 'svg_icon_path'
                }
            ],
            required: true
        },
        activeTab: {
            type: String,
            default: "id_string",
            required: true
        },
        classes: {
            default: ""
        }
    }, 
    mounted: function () {
        this.selectedTab = this.activeTab
    },
    data() {
        return {
            Config,
            selectedTab: ''
        }
    },      
    methods: {
        switchTo(target) {
            this.selectedTab = target
            this.$emit("callSwitchScreen", target)
        }        
    }
}
</script>

<style>
</style>